// フォームクリア
import commonClass from "./commonClass";

export default class descriptionListClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }

  // class変数定義
  _classValiableDefine() {
    this._$prt = $('.js-descriptionList_prt');

    this._showBtn = '.js-descriptionList_open';
    this._closeBtn = '.js-descriptionList_close';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    cls._$prt.each(function(index, el) {
      var $self = $(this);
      var $tgt = $self.find('.c-descriptionList');
      var $showBtn = $self.find(cls._showBtn);
      var $closeBtn = $self.find(cls._closeBtn);

      $showBtn.on('click', function() {
        $tgt.removeClass('is-close');
      })
      $closeBtn.on('click', function() {
        $tgt.addClass('is-close');
        //@2010.11.18 SBCr追加 START
        $('.js-tab-l').click(function () {
          $tgt.removeClass('is-close');
        });
        //@2010.11.18 SBCr追加 END
      })
    });
  }
}